import { compareSeq, type Seq } from "../contract/chat.events";

export { compareSeq };

/** The larger of two seq values (CONTRACT §0 — never via Number()). */
export function maxSeq(a: Seq, b: Seq): Seq {
  return compareSeq(a, b) >= 0 ? a : b;
}

/** `a` strictly after `b`; a missing `b` counts as "nothing seen yet". */
export function isSeqAfter(a: Seq, b: Seq | null | undefined): boolean {
  return b == null || compareSeq(a, b) > 0;
}

export function isSeq(value: unknown): value is Seq {
  return typeof value === "string" && /^(0|[1-9]\d*)$/.test(value);
}
